import React from 'react';
import { connect } from 'react-redux';
import IdUploaded from 'registration/creative/components/id_uploaded';

const mapStateToProps = ({ creativeRegistration: { registrationSubmittedAt, idValidated } }) => ({
  registrationSubmittedAt,
  idValidated
})

export default connect(mapStateToProps)(IdUploaded);



// WEBPACK FOOTER //
// ./registration/creative/containers/id_uploaded.js